<template>
  <div class="header white-bg page-component__scroll" :class="scrollNav?'scrollTop':''">
    <div class="container">
      <el-row>
        <el-col class="header-log" :span="2">
          <img src="../../static/images/index/log.png" >
        </el-col>
        <el-col class="header-nav" :span="22" :class="showList?'showlist':''">
					<div class="lay-shadow" @click="closeShadow()"></div>
          <ul class="nav-list" :class="currlangs==2?'sp':''">
						<li :class="activeIndex==1?'lst-active':''" @click="handActive('1')">
							<router-link to="/" tips="首页">{{ langs.header1 }}<i class="show-xs show-xs-icon el-icon-arrow-right"></i></router-link>
						</li>
						<li :class="activeIndex==2?'lst-active':''" @click="handActive('2')">
							<router-link to="/iotManage" tips="IoT解决方案">{{ langs.header2 }}<i class="show-xs show-xs-icon el-icon-arrow-right"></i></router-link>
						</li>
						<li :class="activeIndex==3?'lst-active':''" @click="handActive('3')">
							<router-link to="/aboutus" tips="关于我们">{{ langs.header3 }}<i class="show-xs show-xs-icon el-icon-arrow-right"></i></router-link>
						</li>
						<li :class="activeIndex==4?'lst-active':''" @click="handActive('4')">
							<router-link to="/products" tips="产品中心">{{ langs.header4 }}<i class="show-xs show-xs-icon el-icon-arrow-right"></i></router-link>
						</li>
						<li :class="activeIndex==5?'lst-active':''" @click="handActive('5')">
							<router-link to="/cases" tips="案例展示">{{ langs.header5 }}<i class="show-xs show-xs-icon el-icon-arrow-right"></i></router-link>
						</li>
						<li :class="activeIndex==6?'lst-active':''" @click="handActive('6')">
							<router-link to="/custom" tips="定制中心">{{ langs.header6 }}<i class="show-xs show-xs-icon el-icon-arrow-right"></i></router-link>
						</li>
						<li :class="activeIndex==8?'lst-active':''" @click="handActive('8')">
							<router-link to="/contactus" tips="联系我们">{{ langs.header7 }}<i class="show-xs show-xs-icon el-icon-arrow-right"></i></router-link>
						</li>
						<li class="show-xs">
							<!-- <a href="http://www.upusiot.cn/upus" tips="登录">{{ langs.header8 }}<i class="show-xs show-xs-icon el-icon-arrow-right"></i></a> -->
							<!-- <a href="http://www.upus.cn/upus" tips="登录">{{ langs.header8 }}<i class="show-xs show-xs-icon el-icon-arrow-right"></i></a> -->
							<a :href="jeeurl" tips="登录">{{ langs.header8 }}<i class="show-xs show-xs-icon el-icon-arrow-right"></i></a>
						</li>
						<li class="show-xs" v-show="currlangs==0">
							<a href="http://www.upus.cn/admin/account.html" target="_blank" tips="开户">{{ langs.header9 }}<i class="show-xs show-xs-icon el-icon-arrow-right"></i></a>
						</li>
						<li class="show-xs">
							<a href="javascript:;" @click="changeEng(0)">中文<i class="show-xs show-xs-icon el-icon-arrow-right"></i></a>
						</li>
						<li class="show-xs">
							<a href="javascript:;" @click="changeEng(1)">English<i class="show-xs show-xs-icon el-icon-arrow-right"></i></a>
						</li>
						<li class="show-xs">
							<a href="javascript:;" @click="changeEng(2)">español<i class="show-xs show-xs-icon el-icon-arrow-right"></i></a>
						</li>
					</ul>
					<div class="show-lg fr head-right">
						<p class="head-login">
							<!-- <a href="http://www.upusiot.cn/upus" tips="登录">{{ langs.header8 }}</a> -->
							<!-- <a href="http://www.upus.cn/upus" tips="登录">{{ langs.header8 }}</a> -->
							<a :href="jeeurl" tips="登录">{{ langs.header8 }}</a>
							<a href="http://www.upus.cn/admin/account.html" target="_blank" tips="开户" v-show="currlangs==0">{{ langs.header9 }}</a>
						</p>
						<p class="head-lang">
							<a href="javascript:;" @click="changeEng(0)">中文</a>
							<span>|</span>
							<a href="javascript:;" @click="changeEng(1)">English</a>
							<span>|</span>
							<a href="javascript:;" @click="changeEng(2)">español</a>
						</p>
					</div>
          <div class="toggle-nav" @click="toggleNav()">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
				jeeurl: '',
        activeIndex: '1',
        showList:false, // 显示/隐藏导航栏
				scrollNav: false,

				currlangs: 1, //0中文 1英文 2西班牙语
				langs: zh,
      };
    },
		mounted() {
      // console.info(this.$route.path);
			let _this = this;
			let langs1 = sessionStorage.getItem('UPUS_langs');
			if(langs1) {
				_this.currlangs = langs1;
			}
			let servetype = '';
			if(_this.currlangs == 2) {
				_this.langs = sp;
				servetype = 3;
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
				servetype = 2;
			} else {
				_this.langs = zh;
				servetype = null;
			}
      if(servetype) {
        _this.jeeurl = 'http://www.upusiot.cn/upus?type='+servetype;
        // _this.jeeurl = 'http://www.upus.cn/upus?type='+servetype;
      } else {
        _this.jeeurl = 'http://www.upusiot.cn/upus';
        // _this.jeeurl = 'http://www.upus.cn/upus';
      }
			// console.info(_this.currlangs);
			sessionStorage.setItem('UPUS_langs', _this.currlangs);
			let path = _this.$route.path;
			let index = path.indexOf("/", 2);
			if(index!= '-1') {
				path = path.substr(0, index);
			}
			// console.info(path)
			if(path == '/iotManage') {
				_this.activeIndex = 2;
			} else if(path == '/aboutus') {
				_this.activeIndex = 3;
			} else if(path == '/products') {
				_this.activeIndex = 4;
			} else if(path == '/cases') {
				_this.activeIndex = 5;
			} else if(path == '/custom') {
				_this.activeIndex = 6;
			} else if(path == '/news') {
				_this.activeIndex = 7;
			} else if(path == '/contactus') {
				_this.activeIndex = 8;
			} else {
				_this.activeIndex = 1;
			}
			// console.info(_this.activeIndex);
			window.addEventListener("scroll", _this.handleScroll);
		},
		watch:{
		  $route(to,from){
		    // console.log(to.path);
				let path1 = to.path;
				let index1 = path1.indexOf('/', 2);
				// console.info(index1)
				if(index1!='-1') {
					path1 = path1.substring(0, index1);
				}
				// console.info(path1)
				if(path1=='/iotManage') {
					this.activeIndex = 2;
				} else if(path1 == '/aboutus') {
					this.activeIndex = 3;
				} else if(path1 == '/products') {
					this.activeIndex = 4;
				} else if(path1 == '/cases') {
					this.activeIndex = 5;
				} else if(path1 == '/custom') {
					this.activeIndex = 6;
				} else if(path1 == '/news') {
					this.activeIndex = 7;
				} else if(path1 == '/contactus') {
					this.activeIndex = 8;
				} else {
					this.activeIndex = 1;
				}
				// console.info(this.activeIndex)
        // console.info(_this.currlangs)
		  }
		},
    methods: {
			// 修改语言
			changeEng(langstype) {
				let _this = this;
				_this.currlangs = langstype;
				let servetype = null;
				// const loading = _this.$loading({ text:'Loading...', background: 'rgba(0, 0, 0, 0.7)' });
				if(_this.currlangs == 1) {
					_this.langs = eng;
					servetype = 2;
				} else if(_this.currlangs == 2) {
					_this.langs = sp;
					servetype = 3;
				} else {
					_this.langs = zh;
					servetype = null;
				}
        if(servetype) {
          _this.jeeurl = 'http://www.upusiot.cn/upus?type='+servetype;
          // _this.jeeurl = 'http://www.upus.cn/upus?type='+servetype;
        } else {
          _this.jeeurl = 'http://www.upusiot.cn/upus';
          // _this.jeeurl = 'http://www.upus.cn/upus';
        }
				sessionStorage.setItem('UPUS_langs', _this.currlangs);
				location.reload();
			},
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				// console.log(scrollTop)
				if(scrollTop>80){
					this.scrollNav = true;
				}else{
					this.scrollNav = false;
				}
			},
      handActive(index) {
        this.activeIndex = index;
				this.showList = false;
      },
      toggleNav() {
        this.showList = !this.showList;
      },
			closeShadow() {
				this.showList = !this.showList;
			}
    }
  };
</script>

<style scoped>
  .header{
    width: 100%;
    position: relative;
		transition:all 0.5s;
  }
  .header-log img{
    display: inline-block;
    width: 60px;
		margin-top: 5px;
  }
  .header-nav{
    font-size: 16px;
    font-weight: 600;
  }
	.scrollTop{
		position: fixed;
		top: 0px;
		width: 100%;
		z-index: 999999999;
		-webkit-animation: fadeInDown .3s;
		animation: fadeInDown .3s;
		box-shadow: 0px 1px 5px #999;
	}
	@keyframes fadeInDown{
		0% {
		  opacity: 0;
		  -webkit-transform: translateY(-20px);
		  transform: translateY(-20px);
		}
		100% {
		  opacity: 1;
		  -webkit-transform: translateY(0);
		  transform: translateY(0);
		}
	}
	.nav-list{
		display: inline-block;
	}
  .nav-list li{
    display: inline-block;
  }
  .nav-list li a{
    display: inline-block;
    padding: 26px 12px;
    cursor: pointer;
  }
  .nav-list.sp li a{
    padding: 26px 6px;
  }
  .nav-list li:hover a{
    color: #1841b5;
  }
  .lst-active a{
    color: #1841b5;
    position: relative;
    /* border-bottom: 3px solid #1841b5; */
  }
  .lst-active a::after{
    content: "";
    position: absolute;
    left: 10%;
    bottom: 0;
    width: 80%;
    height: 3px;
    background-color: #1841b5;
    z-index: 1;
  }
  .toggle-nav span{
    display: none;
  }
	.lay-shadow{
		background-color: #000000;
		opacity: 0.3;
	}
	.container .show-xs{
		display: none;
	}
	.container .show-xs-icon{
		float: right;
	}
	.container .show-lg{
		display: block;
	}
	.head-right{
		height: 69px;
		line-height: 69px;
	}
	.head-right p{
		display: inline-block;
		margin: 0px;
		padding: 0px;
	}
	.head-right a:hover{
		color: #1841b5;
	}
	.head-login a{
		padding: 0px 5px;
		height: 69px;
		display: inline-block;
		color: #333;
		font-size: 15px;
		font-weight: 100;
	}
	.head-lang span{
		color: #ccc;
	}
	.head-lang a{
		padding: 0px 5px;
		height: 69px;
		display: inline-block;
		font-size: 13px;
		color: #999;
		font-weight: 100;
	}
  @media screen and (max-width:768px) {
		.container .show-xs{
			display: block;
		}
		.container .show-lg{
			display: none;
		}
    .nav-list{
      position: fixed;
      left: -300px;
      top: 0px;
      width: 70%;
      height: 100%;
      background-color: #fff;
			transition: 0.3s;
			z-index: 99999;
    }
    .nav-list li{
      display: block;
      padding: 0px;
      border-bottom: 1px solid #eee;
    }
    .nav-list li a{
      padding: 10px 12px;
      font-weight: 100;
      display: block;
    }
    .lst-active a::after{
      height: 0px;
    }
    .toggle-nav{
      float: right;
      margin: 22px 12px 0px 0px;
    }
    .toggle-nav span {
      display: block;
      width: 24px;
      height: 2px;
      background: #1841b5;
      margin-bottom: 6px;
      transition: 0.3s;
    }
    .showlist .nav-list{
      left: 0px;
			z-index: 10010;
    }
    .showlist .toggle-nav span:nth-child(1) {
      transform: translate(1px, 10px) rotate(-48deg);
    }
    .showlist .toggle-nav span:nth-child(2) {
      opacity: 0;
      visibility: hidden;
    }
    .showlist .toggle-nav span:nth-child(3) {
      transform: translate(1px, -6px) rotate(44deg);
    }
		.lay-shadow{
			position: fixed;
			left: 0px;
			top: 0px;
			width: 100%;
			height: 100%;
			display: none;
		}
		.showlist .lay-shadow{
			display: block;
			z-index: 10005;
		}
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue